module.exports = __webpack_public_path__ + "img/wallet-icon-black.311b389e.svg";